<template>
	<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">

		<!--input类型示例-->
		<FormItem prop="trackName">
			<FormItem prop="trackName">
				<Input style="width: 260px;" type="text" v-model="formInline.OperatorId" placeholder="用户名称">
				<span slot="prepend">用户名称</span>
				</Input>
			</FormItem>
		</FormItem>

		<!--select类型示例-->
		<FormItem label="充电卡状态:" :label-width="100" prop="trackName">
			<Select placeholder="充电卡状态" style="width: 200px;" v-model="formInline.Status">
				<Option :value='-1'>全部</Option>
				<Option :value='0'>正常</Option>
				<Option :value='1'>锁定</Option>
				<Option :value='256'>挂失</Option>
				<Option :value='516'>注销</Option>
			</Select>
		</FormItem>
		<!--select类型示例2-->
		<FormItem v-if='ifAddPrice' prop="trackName" label="查询模板名称:" :label-width="100">
			<Select v-model="selectPriceId" filterable placeholder="模板列表" style="width: 200px;" @on-change="showPriceModel">
		
				<Option :key="itemIndex" v-for="(item,itemIndex) in PriceList" :value="item.Id">{{item.Name}}</Option>
		
			</Select>
		</FormItem>



		<!--时间类型示例-->
		<FormItem label="选择时间" :label-width='70'>

			<DatePicker style="width: 110px;" :type="formInline.dateType" placeholder="Select date" v-model="formInline.QueryTime"></DatePicker>

		</FormItem>


		<FormItem>
			<Button type="primary" @click="$emit('handleSubmit')">查询</Button>
		</FormItem>

		<div style="float: right;">
			<Button type="primary" @click="$emit('show','add')">用户添加</Button>
			<!-- <Button style="float: left;margin-left: 5px;" type="primary" @click="show('addExcel')">批量导入</Button> -->
		</div>
	</Form>
</template>

<script>
	export default {
		//props: ['param', 'url'],
		data() {
			return {
				formInline: {
					OperatorId: '',
					Status: 0,
					dateType: 'datetime', //date year month datetime
					QueryTime: ''

				},
				
				PriceList:[
					{
						Id:0,
						Name:'name'
					}
				]
			};
		},
		computed: {
			// pageParam: function() {
			// 	const _this = this;
			// 	const param = {
			// 		OperatorId: _this.formInline.OperatorId

			// 	}
			// 	return param
			// },
		},
		methods: {},
	}
</script>

<style>
</style>
